import {api} from "../../shared/utils";
import {environment} from "../../config/environment";

const baseUrl = environment.apiBaseURLClients;

const buildQuery = (params = {}) => {
    const query = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value == null || value === '') return;
        query.set(key, value);
    });

    return query.toString();
};

export const getFinanceiroDashboard = () => api.get(`${baseUrl}/financeiro/dashboard`);

export const listFinanceiroFaturas = (params = {}) => {
    const query = buildQuery(params);
    return api.get(`${baseUrl}/financeiro/faturas${query ? `?${query}` : ''}`);
};

export const getFinanceiroFaturaDetails = (id) => api.get(`${baseUrl}/financeiro/faturas/${id}`);

export const generateFinanceiroFatura = (payload) => api.post(`${baseUrl}/financeiro/faturas/gerar`, payload);

export const reprocessFinanceiroFatura = (id) => api.post(`${baseUrl}/financeiro/faturas/${id}/reprocessar`);

export const notifyFinanceiroFatura = (id) => api.post(`${baseUrl}/financeiro/faturas/${id}/notificar`);

export const listFinanceiroInadimplencia = () => api.get(`${baseUrl}/financeiro/inadimplencia`);

export const blockFinanceiroLicenca = (id) => api.post(`${baseUrl}/financeiro/licencas/${id}/bloquear`);

export const reactivateFinanceiroLicenca = (id) => api.post(`${baseUrl}/financeiro/licencas/${id}/reativar`);

export const listEmpresasFinanceiroReference = () => api.get(`${baseUrl}/empresas?page=1&pageSize=300&sortBy=razao_social&order=asc`);

export const listFinanceiroContasBancarias = (params = {}) => {
    const query = buildQuery(params);
    return api.get(`${baseUrl}/financeiro/contas-bancarias${query ? `?${query}` : ''}`);
};

export const getFinanceiroContaBancaria = (id) => api.get(`${baseUrl}/financeiro/contas-bancarias/${id}`);

export const createFinanceiroContaBancaria = (payload) => api.post(`${baseUrl}/financeiro/contas-bancarias`, payload);

export const updateFinanceiroContaBancaria = (id, payload) => api.put(`${baseUrl}/financeiro/contas-bancarias/${id}`, payload);

export const deleteFinanceiroContaBancaria = (id, usuarioId) => api.delete(`${baseUrl}/financeiro/contas-bancarias/${id}?${buildQuery({usuarioId})}`);

export const testFinanceiroContaBancaria = (id) => api.post(`${baseUrl}/financeiro/contas-bancarias/${id}/testar-conexao`);

export const listFinanceiroFormasPagamento = (params = {}) => {
    const query = buildQuery(params);
    return api.get(`${baseUrl}/financeiro/formas-pagamento${query ? `?${query}` : ''}`);
};

export const getFinanceiroFormasPagamento = (id) => api.get(`${baseUrl}/financeiro/formas-pagamento/${id}`);

export const createFinanceiroFormasPagamento = (payload) => api.post(`${baseUrl}/financeiro/formas-pagamento`, payload);

export const updateFinanceiroFormasPagamento = (id, payload) => api.put(`${baseUrl}/financeiro/formas-pagamento/${id}`, payload);

export const deleteFinanceiroFormasPagamento = (id) => api.delete(`${baseUrl}/financeiro/formas-pagamento/${id}`);

export const listFinanceiroBanco = (params = {}) => {
    const query = buildQuery(params);
    return api.get(`${baseUrl}/financeiro/bancos${query ? `?${query}` : ''}`);
};

export const getFinanceiroBanco = (id) => api.get(`${baseUrl}/financeiro/bancos/${id}`);

export const createFinanceiroBanco = (payload) => api.post(`${baseUrl}/financeiro/bancos`, payload);

export const updateFinanceiroBanco = (id, payload) => api.put(`${baseUrl}/financeiro/bancos/${id}`, payload);

export const deleteFinanceiroBanco = (id) => api.delete(`${baseUrl}/financeiro/bancos/${id}`);

export const listFinanceiroBoletos = (params = {}) => {
    const query = buildQuery(params);
    return api.get(`${baseUrl}/financeiro/boletos${query ? `?${query}` : ''}`);
};

export const getFinanceiroBoleto = (id) => api.get(`${baseUrl}/financeiro/boletos/${id}`);

export const createFinanceiroBoleto = (payload) => api.post(`${baseUrl}/financeiro/boletos`, payload);

export const getFinanceiroBoletoPdf = (id) => api.get(`${baseUrl}/financeiro/boletos/${id}/pdf`);

export const cancelFinanceiroBoleto = (id, payload) => api.post(`${baseUrl}/financeiro/boletos/${id}/cancelar`, payload);

export const getFinanceiroBoletoHistorico = (id) => api.get(`${baseUrl}/financeiro/boletos/${id}/historico`);

export const resendFinanceiroBoletoEmail = (id) => api.post(`${baseUrl}/financeiro/boletos/${id}/reenviar-email`);

export const listFinanceiroContasReceber = (params = {}) => {
    const query = buildQuery(params);
    return api.get(`${baseUrl}/financeiro/contas-receber${query ? `?${query}` : ''}`);
};

export const getFinanceiroContaReceber = (id) => api.get(`${baseUrl}/financeiro/contas-receber/${id}`);

export const createFinanceiroContaReceber = (payload) => api.post(`${baseUrl}/financeiro/contas-receber`, payload);

export const updateFinanceiroContaReceber = (id, payload) => api.put(`${baseUrl}/financeiro/contas-receber/${id}`, payload);

export const settleFinanceiroContaReceber = (id, payload) => api.post(`${baseUrl}/financeiro/contas-receber/${id}/baixar`, payload);

export const deleteFinanceiroContaReceber = (id, usuarioId) => api.delete(`${baseUrl}/financeiro/contas-receber/${id}?${buildQuery({usuarioId})}`);

export const getFinanceiroContaReceberHistorico = (id) => api.get(`${baseUrl}/financeiro/contas-receber/${id}/historico`);

// Cobranças da fatura e da tela de cobranças (BBF-158). O app-financeiro responde sem envelope.
export const listCobrancasDaFatura = (faturaId) => api.get(`${baseUrl}/financeiro/cobrancas?${buildQuery({fatura_id: faturaId})}`);

export const listCobrancas = (params = {}) => {
    const query = buildQuery(params);
    return api.get(`${baseUrl}/financeiro/cobrancas${query ? `?${query}` : ''}`);
};

export const getCobranca = (id) => api.get(`${baseUrl}/financeiro/cobrancas/${id}`);

export const registrarPagamentoManual = (id, body) => api.post(`${baseUrl}/financeiro/cobrancas/${id}/pagamento-manual`, body);

export const getRegua = () => api.get(`${baseUrl}/financeiro/regua`);

// Link curto (5 min) do PDF da fatura, gerado na hora se faltar (BBF-141).
export const getPdfDaFatura = (id) => api.get(`${baseUrl}/financeiro/faturas/${id}/pdf`);
